
import { WorldCountry } from '../types';

// Fase 12 - Expansión Oceanía: Países del Pacífico expandidos
export const oceaniaExpansion4: WorldCountry[] = [
  // Samoa (Fase 12)
  {
    name: 'Samoa',
    slug: 'samoa',
    code: 'WS',
    population: 198414,
    topCities: [
      { name: 'Apia', slug: 'apia', population: 37708 },
      { name: 'Asau', slug: 'asau', population: 1200 },
      { name: 'Mulifanua', slug: 'mulifanua', population: 4500 },
      { name: 'Leulumoega', slug: 'leulumoega', population: 4745 },
      { name: 'Lufilufi', slug: 'lufilufi', population: 1500 },
      { name: 'Falealupo', slug: 'falealupo', population: 800 },
      { name: 'Salelologa', slug: 'salelologa', population: 5830 },
      { name: 'Fagamalo', slug: 'fagamalo', population: 1200 },
      { name: 'Safotulafai', slug: 'safotulafai', population: 1188 },
      { name: 'Vailoa', slug: 'vailoa', population: 1000 },
      { name: 'Siumu', slug: 'siumu', population: 2000 },
      { name: 'Falelatai', slug: 'falelatai', population: 2500 },
      { name: 'Solosolo', slug: 'solosolo', population: 1800 },
      { name: 'Fasitoouta', slug: 'fasitoouta', population: 3500 },
      { name: 'Vaitele', slug: 'vaitele', population: 7000 },
      { name: 'Nofoalii', slug: 'nofoalii', population: 2200 },
      { name: 'Lotofaga', slug: 'lotofaga', population: 1600 },
      { name: 'Poutasi', slug: 'poutasi', population: 900 },
      { name: 'Lalomanu', slug: 'lalomanu', population: 500 },
      { name: 'Aleipata', slug: 'aleipata', population: 1100 }
    ]
  },
  // Tonga (Fase 12)
  {
    name: 'Tonga',
    slug: 'tonga',
    code: 'TO',
    population: 105695,
    topCities: [
      { name: 'Nuku\'alofa', slug: 'nukualofa', population: 24229 },
      { name: 'Neiafu', slug: 'neiafu', population: 4320 },
      { name: 'Haveluliku', slug: 'haveluliku', population: 3417 },
      { name: 'Vaini', slug: 'vaini', population: 2976 },
      { name: 'Pangai', slug: 'pangai', population: 1738 },
      { name: 'Ohonua', slug: 'ohonua', population: 1241 },
      { name: 'Kolonga', slug: 'kolonga', population: 1199 },
      { name: 'Holonga', slug: 'holonga', population: 800 },
      { name: 'Hihifo', slug: 'hihifo', population: 1515 },
      { name: 'Foa', slug: 'foa', population: 1200 },
      { name: 'Lifuka', slug: 'lifuka', population: 2900 },
      { name: 'Nomuka', slug: 'nomuka', population: 400 },
      { name: 'Hunga', slug: 'hunga', population: 200 },
      { name: 'Uiha', slug: 'uiha', population: 600 },
      { name: 'Tatakamotonga', slug: 'tatakamotonga', population: 1500 },
      { name: 'Mu\'a', slug: 'mua', population: 5142 },
      { name: 'Lapaha', slug: 'lapaha', population: 1300 },
      { name: 'Niutoua', slug: 'niutoua', population: 950 },
      { name: 'Pea', slug: 'pea', population: 1200 },
      { name: 'Houma', slug: 'houma', population: 2800 }
    ]
  },
  // Vanuatu (Fase 12)
  {
    name: 'Vanuatu',
    slug: 'vanuatu',
    code: 'VU',
    population: 307145,
    topCities: [
      { name: 'Port Vila', slug: 'port-vila', population: 51437 },
      { name: 'Luganville', slug: 'luganville', population: 16312 },
      { name: 'Norsup', slug: 'norsup', population: 3000 },
      { name: 'Isangel', slug: 'isangel', population: 1200 },
      { name: 'Sola', slug: 'sola', population: 1700 },
      { name: 'Lenakel', slug: 'lenakel', population: 1100 },
      { name: 'Longana', slug: 'longana', population: 800 },
      { name: 'Saratamata', slug: 'saratamata', population: 900 },
      { name: 'Lakatoro', slug: 'lakatoro', population: 900 },
      { name: 'Craig Cove', slug: 'craig-cove', population: 600 },
      { name: 'Lolowai', slug: 'lolowai', population: 500 },
      { name: 'Melsisi', slug: 'melsisi', population: 400 },
      { name: 'Whitegrass', slug: 'whitegrass', population: 700 },
      { name: 'Aneityum', slug: 'aneityum', population: 300 },
      { name: 'Blacksands', slug: 'blacksands', population: 2500 }
    ]
  }
];
